import { BadgeVerifiedCredentials } from '@seek/certsy-ui';
import { useTranslations } from '@vocab/react';
import { Box, TooltipRenderer, Text, Stack, List } from 'braid-design-system';

import translations from './.vocab';

export const VerifiedCredentialsBadge = ({
  idSuffix,
  verificationsCount,
  verifications,
}: {
  idSuffix: string;
  verificationsCount: number;
  verifications: string[];
}) => {
  const { t } = useTranslations(translations);
  const maxVerificationsToShow = 4;
  return (
    <TooltipRenderer
      id={`seek-pass-verified-credentials-tooltip-${idSuffix}`}
      tooltip={
        <Stack space="large">
          <List space="xsmall">
            {verifications
              .slice(0, maxVerificationsToShow)
              .map((verification, index) => (
                <Text key={index} weight="strong" size="small">
                  {index === maxVerificationsToShow - 1 &&
                  verificationsCount > maxVerificationsToShow
                    ? t('{verification} + {verificationsHiddenCount} more', {
                        verification,
                        verificationsHiddenCount:
                          verificationsCount - maxVerificationsToShow,
                      })
                    : verification}
                </Text>
              ))}
          </List>

          <Text size="small">
            {t('View verification tab for more details.')}
          </Text>
        </Stack>
      }
    >
      {({ triggerProps }) => (
        <Box {...triggerProps}>
          <BadgeVerifiedCredentials>
            {t('Verified credentials ({count})', { count: verificationsCount })}
          </BadgeVerifiedCredentials>
        </Box>
      )}
    </TooltipRenderer>
  );
};
